export default __webpack_public_path__ + "img/map-marker-adult_centers-active.1d57367f.png";